import { useQuery } from '@tanstack/react-query';
import {
  experiencesGetAll,
  PublisherResource,
  ServiceEventResource,
  ShiftResource,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export type Experience = {
  id: number;
  currentState: string;
  title: string;
  isPositive: boolean;
  turn?: {
    route: {
      name: string;
    };
    language: string;
    shift: ShiftResource;
  };
  publisher: PublisherResource;
  events: ServiceEventResource[];
};

export const useExperiences = ({
  publisherId,
}: { publisherId?: number } = {}) =>
  useQuery({
    queryFn: async () =>
      extractData(
        experiencesGetAll({
          query: {
            expand: ['turn.route', 'turn.shift', 'publisher', 'events'],
            filter: publisherId ? [`publisher=${publisherId}`] : undefined,
          },
        })
      ) as unknown as Experience[],
    queryKey: ['Experiences', publisherId],
  });
